module.exports = __webpack_public_path__ + "img/eye-in-office.5d0cf3cb.jpg";